var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en

angular.module('inputTextareaCmp', [])
  .component('inputTextarea', {
    template: require('./input-textarea.component.tpl.html'),
    controller: InputTextareaCtrl,
    controllerAs: 'vm',
    bindings: {
      formField: '<',
      value: '='
    }
  })

InputTextareaCtrl.$inject = ['i18n']

function InputTextareaCtrl (i18n) {
  var vm = this

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)

    if (vm.formField.defaultValueI18N) {
      vm.value[vm.formField.id] = vm.formField.defaultValueI18N
    }

    if (vm.formField.itemSize > 0 && vm.formField.itemSize < 2000) {
      vm.maxlengthTextarea = vm.formField.itemSize
    } else {
      vm.maxlengthTextarea = 2000
    }
  }
}
